module.exports = __webpack_public_path__ + "img/404.5ba44702.gif";